module.exports = __webpack_public_path__ + "img/img-e067e3.png";